<template>
    <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="账号：">
            <el-input v-model="formInline.loginName" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="车牌号：">
            <el-input v-model="formInline.licencePlate" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
            <el-select style="width: 130px;" v-model="formInline.state" filterable placeholder="请选择">
                <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
        </el-form-item>
    </el-form>
    
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="账号" min-width="200" show-overflow-tooltip>
            <template #default="scope">
              <div>
                <span>{{ scope.row.loginName }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="姓名">
            <template #default="scope">
              <div>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="手机号" min-width="150">
            <template #default="scope">
              <div>
                <span>{{ scope.row.phoneNumber }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="余额（元）" min-width="100">
            <template #default="scope">
              <div>
                <span>{{ scope.row.balance }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="车牌号" min-width="100">
            <template #default="scope">
              <div>
                <span>{{ scope.row.licencePlate }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="状态">
            <template #default="scope">
              <div>
                <span>{{ stateFilter(scope.row.state) }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="等级">
            <template #default="scope">
              <div>
                <span>{{ gradeFilter(scope.row.grade) }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="注册时间" min-width="200">
            <template #default="scope">
              <div>
                <span>{{ scope.row.registerTime }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="280" fixed="right">
            <template #default="scope">
            <el-button size="small" @click="openRecord(scope.$index, scope.row)">
                交易账单
            </el-button>
            <el-button type="success" size="small" v-if="scope.row.state == 2" @click="changeState(scope.$index, scope.row)">
                解冻
            </el-button>
            <el-button
                size="small"
                type="warning"
                v-if="scope.row.state == 1"
                @click="changeState(scope.$index, scope.row)"
            >
                冻结
            </el-button>
            <el-button
                size="small"
                v-if="scope.row.state != 3"
                type="danger"
                @click="setBlackList(scope.$index, scope.row)"
            >
                设置黑名单
            </el-button>
            </template>
        </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 交易账单 -->
    <el-dialog
        title="交易账单"
        v-model="dialogVisible"
        width="80%"
        :close-on-click-modal="false"
    >
      <el-form :inline="true" :model="searchRecord" class="demo-form-inline">
        <el-form-item label="交易日期：">
            <el-date-picker
                v-model="pickerValue"
                value-format="YYYY-MM-DD"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
            />
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getRecordList">查询</el-button>
        </el-form-item>
      </el-form>

        <el-table
            :data="recordList"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            style="width: 100%;"
        >
            <el-table-column label="交易流水号" min-width="200" show-overflow-tooltip>
                <template #default="scope">
                <div>
                    <span>{{ scope.row.tradeNo }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="交易日期" width="200">
                <template #default="scope">
                <div>   
                    <span>{{ scope.row.tradeTime }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="交易金额(元)">
                <template #default="scope">
                <div>   
                    <span>{{ scope.row.tradeAmt }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="支付类型">
                <template #default="scope">
                <div>   
                    <span>{{ payTypeFilter(scope.row.payType) }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="交易类型">
                <template #default="scope">
                <div>   
                    <span>{{ tradeTypeFilter(scope.row.tradeType) }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="交易状态">
                <template #default="scope">
                <div>   
                    <span>{{ tradeStatusFilter(scope.row.tradeStatus) }}</span>
                </div>
                </template>
            </el-table-column>
            <el-table-column label="剩余金额(元)">
                <template #default="scope">
                <div>   
                    <span>{{ scope.row.remainingAmt }}</span>
                </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <Pagination
            v-model:current-page="currentPage2"
            v-model:page-size="pageSize2"
            :total="total2"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
        />
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';

    export default {
        name:'ChargeUserList',
        data() {
            return {
                formInline: {
                    loginName: '', //账号
                    licencePlate: '', //车牌号
                    state: '', //状态  
                },
                stateOptions: [
                    { name: '全部', value: '' },
                    { name: '正常', value: 1 },
                    { name: '冻结', value: 2 },
                    { name: '黑名单', value: 3 },
                ], 
                tableData: [], //列表
                total: 0, //总条数
                currentPage: 1, //当前页
                pageSize: 10, //每页显示条数
                dialogVisible: false, //充电记录弹窗
                pickerValue:'',
                searchRecord: {
                    driverId: '', //用户id
                    beginDate: '', //开始时间
                    endDate: '', //结束时间
                },
                recordList: [], //充电记录列表
                total2: 0, //总条数
                currentPage2: 1, //当前页
                pageSize2: 10, //每页显示条数
            }
        },
        setup() {
            return {
                gradeFilter: (grade) => { //等级
                    switch (grade) {
                        case 0:
                            return '非会员'; 
                        case 1:
                            return '初级会员';
                        case 2:
                            return '银牌会员'; 
                        case 3:
                            return '金牌会员'; 
                        case 4:
                            return '钻石会员';
                        case 5:
                            return '黑金会员'; 
                    } 
                },
                stateFilter: (state) => { //状态
                    switch (state) {
                        case 1:
                            return '正常';
                        case 2:
                            return '冻结';
                        case 3:
                            return '黑名单';
                    }
                },
                tradeTypeFilter: (state) => { //交易类型
                    switch (state) {
                        case 1:
                            return '支出';
                        case 2:
                            return '充值';
                        case 3:
                            return '提现';  
                        case 4:
                            return '退款';
                    }
                },
                tradeStatusFilter: (state) => { //交易状态
                    switch (state) {
                        case 0:
                            return '等待付款';
                        case 1:
                            return '成功';
                        case 2:
                            return '失败';
                        case 3:
                            return '取消';
                    }
                },
                payTypeFilter: (payType) => { //支付类型
                    switch (payType) {
                        case 1:
                            return '平台账户';
                        case 2:
                            return '支付宝APP';
                        case 3:
                            return '微信APP';
                        case 4:
                            return '银联';
                        case 5:
                            return '一卡通';
                        case 6:
                            return '会员卡';
                        case 7:
                            return '服务费优惠币';
                        case 8:
                            return '线下支付';
                        case 9:
                            return '支付宝小程序支付';
                        case 10:
                            return '微信小程序支付';
                        case 11:
                            return '数字人民币';
                        case 12:
                            return '联合支付';
                    }
                },
            } 
        },
        mounted() {
            this.getList(); //获取列表 
        },
        methods: {
            handleSizeChange (val) { //每页显示条数
                this.pageSize = val;
                this.currentPage = 1;
                this.getList();
            },
            handleCurrentChange(val) { //当前页
                this.currentPage = val;
                this.getList(); //获取列表
            },
            handleSizeChange2 (val) { //每页显示条数
                this.pageSize2 = val;
                this.currentPage2 = 1;
                this.openRecord();
            },
            handleCurrentChange2(val) { //当前页
                this.currentPage2 = val;
                this.openRecord(); //获取列表
            },
            getList() { //获取列表
                let that = this;
                let param = {}; 
                param.page = that.currentPage;
                param.pageSize = that.pageSize;
                Object.keys(this.formInline).forEach(key => {
                    param[key] = this.formInline[key];
                });
                that.$axios.post(that.$store.state.platformApi+"driver/user/page",JSON.stringify(param)).then(result => {
                    if(result.code==200){
                        that.tableData = result.data.records;
                        that.total = result.data.total; 
                    }
                })
            },
            showInfo(index,row){
            // 详情
            let that = this;
            this.$axios.post(that.$store.state.platformApi+"driver/user/view/"+row.id).then(result => {
                if(result.code==200){
                
                } 
            }) 
          },
          openRecord(index,row){
            // 打开用户账单弹窗
            this.searchRecord.driverId = row.id;
            this.dialogVisible = true;
            this.getRecordList();
          },
          getRecordList(){
            // 获取用户交易账单
            let that = this;
            let param = {}; 
            if(that.pickerValue){
                if(that.pickerValue[0] && that.pickerValue[1]){
                    param.beginDate = that.pickerValue[0];
                    param.endDate = that.pickerValue[1];
                }
            }
            param.page = that.currentPage2;
            param.pageSize = that.pageSize2;
            param.driverId = that.searchRecord.driverId;
            that.$axios.post(that.$store.state.platformApi+"trade/record/list",JSON.stringify(param)).then(result => {
                if(result.code==200){
                    // that.dialogVisible = true;
                    that.recordList = result.data.records;
                    that.total2 = result.data.total;
                }
            }) 
          },
          changeState(index,row){
                //冻结、解冻用户
                let that = this;
                if(row.state==1){
                    var msg = '确定冻结该用户吗？';
                    var state = 2;
                }else{
                    var msg = '确定解冻该用户吗？';
                    var state = 1;
                }
                this.$confirm(msg,{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                        this.$axios.post(that.$store.state.platformApi+"driver/user/set/freeze/"+row.id+'/'+state).then(result => {
                            if(result.code==200){
                                this.getList(); 
                                ElMessage({
                                    message: '操作成功',
                                    type:'success',
                                })
                            } 
                        })   
                }) 
            },
            setBlackList(index,row){
                //设置黑名单用户
                let that = this;
                this.$confirm('确定设置黑名单吗？',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                .then(_ => {
                        this.$axios.post(that.$store.state.platformApi+"driver/user/set/black/"+row.id).then(result => {
                            if(result.code==200){
                                this.getList(); 
                                ElMessage({
                                    message: '操作成功',
                                    type:'success',
                                })
                            } 
                        })   
                }) 
            },
        }
    }
</script>